import AnnouncementsTable from "./AnnouncementsTable";

export { AnnouncementsTable };
